/**
 * UPT-2069 (L1) — normalisation UNIQUE d'un code de module, d'un alias, d'un domaine ou d'une clé de rubrique :
 * chaîne, sans espaces autour, en minuscules. Les codes réels sont ceux du registre serveur
 * (`core.module_definition.code`) ; la correspondance alias / domaine → module est servie par le serveur
 * (`moduleScopes` de l'auth-context, voir activeModules.ts). Remplace l'ancien `normalizeModuleCode` du registre codé
 * en dur (majuscules sans séparateurs + table d'alias).
 */
export const normalizeModuleKey = (value: unknown): string =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

export default normalizeModuleKey;
